import React from 'react'
import clsx from 'clsx'
import { Typography } from '@material-ui/core'
import ArrowLeft from '@material-ui/icons/ArrowLeft'
import ArrowRight from '@material-ui/icons/ArrowRight'
import { Stack, BookEnds } from '../../../shared'

const TimeseriesAxis = ({
  minLabel,
  maxLabel,
  showLabels = true,
  label,
  className,
  children,
  ...props
}) => {
  return (
    <BookEnds
      className={clsx('scatterplot-axis', className)}
      startLabel={
        showLabels &&
        minLabel.length > 1 && (
          <Stack horizontal>
            <ArrowLeft /> {minLabel}
          </Stack>
        )
      }
      endLabel={
        showLabels &&
        maxLabel.length > 1 && (
          <Stack horizontal>
            {maxLabel} <ArrowRight />
          </Stack>
        )
      }
      {...props}>
      <Typography
        variant="body2"
        component="div"
        style={{ whiteSpace: 'nowrap' }}
      >
        {label} {children}
      </Typography>
    </BookEnds>
  )
}

TimeseriesAxis.propTypes = {}

export default TimeseriesAxis
